import Image from 'app/Components/Shared/Image/image';
import React, {useContext} from 'react';
import SimActivationContext from 'app/Components/Page/SimActivationPage/SimActivationContext';

function SimNone() {
  const [{links}, dispatch] = useContext(SimActivationContext);

  return (
    <div className='SimNone'>
      <h1 className='SimActivationBlock__main__title' />
      <h1 className='SimActivationBlock__top__title'>אוקיי, זה מוזר.</h1>
      <p className='SimActivationBlock__top__link'>לא קיים אצלנו סים עם הפרטים האלה. בטוח שהם נכונים?</p>

      <div className='SimActivationBlock__image'>
        <Image src={require('../images/icons-error.svg')} />
      </div>

      <div className='SimActivationBlock__bottom__button'>
        <a onClick={() => dispatch({type: 'init'})}>ננסה שוב</a>
      </div>

      <div className='SimActivationBlock__bottom__link'>
        <a href={links.personalAreaUrl}>לאזור אישי</a>
      </div>

      <div className='SimActivationBlock__bottom__link'>
        <a href={`tel:${window.Config.technicalSupportPhone}`}>מוזמנים לדבר איתנו ב- {window.Config.technicalSupportPhone}</a>
      </div>
    </div>
  );
}

export default SimNone;
